import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

const Contact = () => {
  return (
    <div className=" bg-[#fff7f1] min-h-screen">
      <Navbar />
      <div className=" pt-14" />
      <div className=" flex justify-center pt-32">
        <h1 className=" league-spartan-extrabold text-3xl md:text-6xl textanime">
          {" "}
          Contact me
        </h1>
      </div>
      <div className=" flex flex-col p-20 w-full items-center">
        <div className="border-y-2 flex justify-between w-screen  sm:w-full md:w-[60%] border-gray-300 textanime textanime2 ">
          <p className="pl-2  text-sm sm:text-md py-5">Location</p>
          <p className=" text-sm sm:text-md py-5 pr-2"> Ahmedabad,India</p>
        </div>
        <div className=" border-b-2 flex justify-between w-screen sm:w-full md:w-[60%] border-gray-300 textanime textanime2  ">
          <p className="pl-2  text-sm sm:text-md py-5">Email</p>
          <p className=" text-sm sm:text-md py-5 pr-2">
            {" "}
            hemildudhat36@gmail.com
          </p>
        </div>
        <div className=" border-b-2 flex justify-between w-screen sm:w-full md:w-[60%] border-gray-300 textanime textanime2  ">
          <p className="pl-2 t text-sm sm:text-md py-5">Linkedin</p>
          <p className=" text-sm sm:text-md py-5 pr-2 underline-offset-2 underline">
            {" "}
            <a href="https://www.linkedin.com/in/hemil-dudhat-52ab51265/">
              @hemildudhat
            </a>
          </p>
        </div>
      </div>
      <div className=" absolute w-full bottom-0">
        <Footer />
      </div>
    </div>
  );
}

export default Contact